import useRouter from 'use-react-router';
import { Routes } from '../../routes/top-level-routes';

export const useIsOnboardingRouteCheck = (): { isOnboardingRoute: boolean } => {
  const {
    match: { path },
  } = useRouter();
  const isOnboardingRoute = path === Routes.signupOnboarding.path;
  return { isOnboardingRoute };
};
